var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.feedTabList.length)?_c('div',{staticClass:"index-feed-tab",style:(_vm.bgStyle)},[_c('scroll-view',{staticClass:"feed-tab-scroll",attrs:{"scroll-x":"","display":"absolute"}},_vm._l((_vm.feedTabList),function(tab,index){return _c('div',{key:tab.data_id,staticClass:"feed-tab-item",attrs:{"id":("index-feed-tab-" + index)},on:{"click":function($event){return _vm.bindClickTab(index)}}},[_c('span',{staticClass:"tab-title",style:({
          color:
            index === _vm.currentIndex
              ? _vm.style.selectedTitleColor
              : _vm.style.unselectTitleColor,
          fontWeight: index === _vm.currentIndex ? 500 : 'normal'
        })},[_vm._v(" "+_vm._s(("" + (tab.title)).slice(0, 8))+" ")]),(tab.subTitle)?_c('span',{staticClass:"tab-sub-title",style:({
          color:
            index === _vm.currentIndex
              ? _vm.style.selectedSubTitleColor
              : _vm.style.unselectSubTitleColor,
          backgroundColor:
            index === _vm.currentIndex ? _vm.style.subTitleBgColor : 'transparent'
        })},[_vm._v(" "+_vm._s(tab.subTitle)+" ")]):_vm._e(),(index === _vm.currentIndex && !tab.subTitle)?_c('span',{staticClass:"bottom-border",style:({ backgroundColor: _vm.style.selectedTitleColor })}):_vm._e()])}),0)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }